import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import '../css/navbar.css';

const PageWrapper = () => {
  const location = useLocation();

  return (
    <div className="customer-page">
      {/* Top Navbar */}
      <nav className="crm-navbar">
        <div className="navbar-container">
          <div className="navbar-brand">
            <Link to="/">My CRM</Link>
          </div>
          <div className="navbar-links">
            <Link to="/">Login</Link>
            <Link to="/add-customer">Add Customer</Link>
          </div>
        </div>
      </nav>

      {/* Sidebar + Main Content */}
      <div className="crm-layout">
        <aside className="crm-sidebar">
          <ul>
            <li className={location.pathname === '/customer' ? 'active' : ''}>
              <Link to="/customer">Dashboard</Link>
            </li>
            <li className={location.pathname === '/add-customer' ? 'active' : ''}>
              <Link to="/add-customer">Add Customer</Link>
            </li>
            <li className={location.pathname === '/settings' ? 'active' : ''}>
              <Link to="/settings">Settings</Link>
            </li>
          </ul>
        </aside>

        <section className="crm-content">
          <Outlet /> 
        </section>
      </div>
    </div>
  );
};

export default PageWrapper;
